export function stripHtml(content: string): string {
  if (!content) { return ''; }

  const tmp = document.implementation.createHTMLDocument('New').body;

  tmp.innerHTML = content;

  for (const element of Array.from(tmp.querySelectorAll('script, style, template'))) {
    element.remove();
  }

  for (const element of Array.from(tmp.querySelectorAll('p, br'))) {
    if (element.tagName === 'BR') {
      element.replaceWith(tmp.ownerDocument.createTextNode('\n'));
    } else {
      element.prepend(tmp.ownerDocument.createTextNode('\n\n'));
      element.append(tmp.ownerDocument.createTextNode('\n\n'));
    }
  }

  return (tmp.textContent || '')
    // Remove repeated pipe separators only when they occupy a whole line.
    .replace(/^[^\S\n]*(?:\|[^\S\n]*){2,}$/gmu, '')
    .replace(/[^\S\n]+\n/gu, '\n')
    .replace(/\n{3,}/gu, '\n\n')
    .trim();
}
